import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import 'photoswipe/style.css'
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css'

/**
 * Initializes PhotoSwipe lightbox on all .js-gallery elements.
 *
 * Each gallery container should have <a> children with:
 *   - href pointing to the full-size image
 *   - data-pswp-width / data-pswp-height for dimensions
 *   - An <img> thumbnail inside the link
 *   - Optionally a .pswp-caption-content element for captions
 */
export function initGallery() {
  const lightbox = new PhotoSwipeLightbox({
    gallery: '.js-gallery',
    children: 'a',
    pswpModule: () => import('photoswipe'),
  })

  new PhotoSwipeDynamicCaption(lightbox, {
    type: 'below',
    captionContent: (slide) => {
      const el = slide.data.element?.querySelector('.pswp-caption-content')
      return el ? el.innerHTML : ''
    },
  })

  lightbox.init()
}
